import {Attachment} from '../backend/interfaces/attachment';
import {PatchAttachment} from '../backend/requests/patch-attachment';
import {BackendApiManager} from '../managers/backend-api';

export class EntityUserAttachmentsRepository {
  // Singleton Instance
  private static _instance: EntityUserAttachmentsRepository;

  static get instance(): EntityUserAttachmentsRepository {
    if (!this._instance) {
      this._instance = new EntityUserAttachmentsRepository();
    }
    return this._instance;
  }

  public async createAttachments(
    entityId: string,
    userId: string,
    attachments: Attachment[]
  ): Promise<Attachment[]> {
    // Set url
    const url: string = `/entities/${entityId}/users/${userId}/attachments`;

    const response = await BackendApiManager.instance.post<Attachment[]>(url, {
      attachments: attachments,
    });

    // Return
    return response.data;
  }

  public async getAttachments(entityId: string, userId: string): Promise<Attachment[]> {
    // Set url
    const url: string = `/entities/${entityId}/users/${userId}/attachments`;

    const response = await BackendApiManager.instance.get<Attachment[]>(url);

    // Return
    return response.data;
  }

  public async patchAttachment(
    entityId: string,
    userId: string,
    attachmentId: string,
    attachment: PatchAttachment
  ): Promise<Attachment> {
    // Set url
    const url: string = `/entities/${entityId}/users/${userId}/attachments/${attachmentId}`;

    const response = await BackendApiManager.instance.patch<Attachment>(url, attachment);

    // Return
    return response.data;
  }

  public async deleteAttachment(
    entityId: string,
    userId: string,
    attachmentId: string
  ): Promise<void> {
    // Set url
    const url: string = `/entities/${entityId}/users/${userId}/attachments/${attachmentId}`;

    await BackendApiManager.instance.delete(url);
  }
}
